import { ProfileMetrics } from '../constants/profileMetrics';
import { PostQueueStatLabelsEnum } from '../components/containers/PostQueueStat/PostQueueStat.view';

// Typeguard to make sure key exists in IconsEnum
function isIconsEnumKey(key: string): key is keyof typeof PostQueueStatLabelsEnum {
  return key in PostQueueStatLabelsEnum;
}

export const mapProfileMetricToIcon = (
  typename: string | undefined,
  metric: ProfileMetrics
): PostQueueStatLabelsEnum | null => {
  // Twitter uses the 'retweets' icon in place of the 'share' icon
  if (typename === 'TwitterSocialProfile' && metric === ProfileMetrics.shares) {
    return PostQueueStatLabelsEnum.retweets;
  }

  // Shares needs to be intentionaly mapped to the 'share' icon
  if (metric === ProfileMetrics.shares) return PostQueueStatLabelsEnum.share;

  if (isIconsEnumKey(metric)) {
    return PostQueueStatLabelsEnum[metric];
  } else {
    return null;
  }
};
